import { useEffect, useState } from "react"
import { Link, NavLink, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import axiosInstance from "../../../hooks/axiosInstance"
import Loader from "../../../components/utilities/Loader/Loader"
import { Pagination } from "@mui/material"

export default function MembershipPage() {
    const {associationId} = useParams()

    const [loading, setLoading] = useState(false)
    const [memberLoading, setMemberLoading] = useState(false)
    const [membership, setMembership] = useState(null)
    const [members, setMembers] = useState([])
    const [filter, setFilter] = useState({
        search: '', status: '', associationId
    })

    const fetchUserMembership = () => {
        setLoading(true)
        axiosInstance.get(`/user/associations/membership/fetch/${associationId}`)
              .then(response => {
                setMembership(response.data.data)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFilterChange = (e) => {
        const {name, value} = e.target

    setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const fetchAssociationMembers = () => {
        setMemberLoading(true)
        axiosInstance.post(`/user/associations/membership/members?page=${page}`, filter)
              .then(response => {
                setMembers(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setMemberLoading(false))
    }


    useEffect(() => {
        fetchUserMembership()
    }, [])

    useEffect(() => {
        fetchAssociationMembers()
    }, [page])
    
    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">My Membership</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Membership</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            <div className="row">
                <div className="col-xxl-3">
                    <div className="card">
                        <div className="card-body p-4">
                            <div>
                                <div className="flex-shrink-0 avatar-md mx-auto">
                                    <div className="avatar-title bg-light rounded">
                                        <img src="/assets/images/companies/img-2.png" alt="" height="50" />
                                    </div>
                                </div>
                                <div className="mt-4 text-center">
                                    <h5 className="mb-1 text-capitalize">{membership?.association?.name}</h5>
                                    <p className="text-muted">{membership?.association?.reg_number}</p>
                                </div>
                                <div className="table-responsive">
                                    <table className="table mb-0 table-borderless">
                                        <tbody>
                                            <tr>
                                                <th><span className="fw-medium">Member ID</span></th>
                                                <td>{membership?.membership_id || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th><span className="fw-medium">Fullname</span></th>
                                                <td>{membership?.user?.last_name || '-'} {membership?.user?.first_name || '-'} {membership?.user?.middle_name_name || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th><span className="fw-medium">Level</span></th>
                                                <td>-</td>
                                            </tr>
                                            <tr>
                                                <th><span className="fw-medium">Email</span></th>
                                                <td>{membership?.user?.email || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th><span className="fw-medium">Date Joined</span></th>
                                                <td>{membership?.joined_on}</td>
                                            </tr>
                                            <tr>
                                                <th><span className="fw-medium">Contact No.</span></th>
                                                <td>{membership?.user?.phone || '-'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading && <Loader />}
                    {/* <!--end card--> */}
                </div>
                {/* <!--end col--> */}

                <div className="col-xxl-9">
                    <div className="card">
                        <div className="card-header border-0 align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Other Members</h4>
                        </div>
                        {/* <!-- end card header --> */}

                        <div className="card-body p-0 pb-2">
                            <div className="row g-4 mb-5 mt-1">
                                <div className="col-sm">
                                    <div className="d-flex gap-2">
                                        <div className="search-box ms-3">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Search..." 
                                                name="search"
                                                value={filter.search}
                                                onChange={handleFilterChange}
                                            />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                        <div>
                                        <button className="btn btn-success w-100" onClick={fetchAssociationMembers}>Filter</button>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--end col--> */}
                            </div>

                            {members.length > 0 ?
                                <>
                                    <div className="row px-3">
                                        <div className="table-responsive table-card">
                                            <table className="table align-middle table-nowrap table-hover" id="customerTable">
                                                <thead className="table-light text-muted">
                                                    <tr>
                                                        <th className="sort" data-sort="currency_name" scope="col">Member Info</th>
                                                        {/* <th className="sort" data-sort="type" scope="col">Membership Type</th> */}
                                                        <th className="sort" data-sort="quantity_value" scope="col">Membership ID</th>
                                                        <th className="sort" data-sort="level" scope="col">Membership Level</th>
                                                        <th className="sort" data-sort="time" scope="col">Date Joined</th>
                                                        {/* <th className="sort" data-sort="status" scope="col">Status</th> */}
                                                        <th className="sort" data-sort="status" scope="col">Membership Status</th>
                                                        {/* <th>Actions</th> */}
                                                    </tr>
                                                </thead>
                                                {/* <!--end thead--> */}
                                                <tbody className="list form-check-all">
                                                    {members.map(member => (
                                                        <tr key={member.id}>
                                                            <td className="id" style={{display:"none"}}><a href="javascript:void(0);" className="fw-medium link-primary">#VZ001</a></td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="flex-shrink-0">
                                                                        <img src="/assets/images/users/avatar-3.jpg" alt="" className="avatar-xs rounded-circle" />
                                                                    </div>
                                                                    <a className="flex-grow-1 ms-2 currency_name">
                                                                        <span className="m-0 text-capitalize">{member.user?.title}. {member.user?.last_name} {member.user?.first_name} {member.user?.middle_name}</span>
                                                                        <p className="m-0 text-muted" style={{lineHeight: 1.5}}>{member.user?.email}</p>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            {/* <td className="type text-success">Free</td> */}
                                                            <td className="id fw-medium link-primary">
                                                                <div className="d-flex gap-3">
                                                                    {member.membership_id ? member.membership_id : '-'}
                                                                    {/* <a href="#" className="link-danger font-weight-bolder cursor-pointer" onClick={() => {setCurrentMember(member); setMembershipIdOpen(true)}}>
                                                                        <i className="ri-edit-box-line"></i>
                                                                    </a> */}
                                                                </div>
                                                            </td>
                                                            <td className="order_date level">
                                                            -
                                                            {/* <a href="#" className="link-danger font-weight-bolder cursor-pointer"><i className="ri-edit-box-line"></i></a> */}
                                                            </td>
                                                            <td className="order_date time" data-timestamp="1641945600">
                                                                {member.joined_on}
                                                            </td>
                                                            <td className="status">
                                                                <span 
                                                                    className={`badge ${member.status == 'active' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}
                                                                >{member.status}</span>
                                                            </td>
                                                            {/* <td>
                                                                <div className="dropdown">
                                                                    <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <i className="ri-more-fill"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu">
                                                                        <li onClick={() => setCurrentMember(member)} data-bs-toggle="offcanvas" data-bs-target="#member-view-offcanvas"><a className="dropdown-item cursor-pointer"><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View Profile</a></li>
                                                                    </ul>
                                                                </div>
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                {/* <!--end tr--> */}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                                        <div className="col-sm-12 d-flex justify-content-end mt-4">
                                            <Pagination 
                                                onChange={handlePageChange}  
                                                count={pageCount} 
                                                color="primary" 
                                                shape="rounded"
                                                size="small"
                                                page={page}
                                            />
                                        </div>
                                        {/* <!-- end col --> */}
                                    </div>
                                </>
                            :
                                <div className="noresult">
                                    <div className="text-center">
                                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                        <h5 className="mt-2">Sorry! No Result Found</h5>
                                        {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {/* <!-- end card --> */}
                    {memberLoading && <Loader />}
                </div>
                {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}
        </>
    )
}